import s from './Overlay.scss';

export const Overlay = () => {
  return `<div class="${s.overlay}"></div>`;
};
